import React, { useState, useRef } from "react";
import PropTypes from "prop-types";

import AppText from "../../../_shared/components/AppText";
import BackIcon from "../../../_shared/components/BackIcon";
import SlideImages from "../../../_shared/components/SlideImages";
import { Modal } from "antd";

// import * as FileSystem from "expo-file-system";
// import * as IntentLauncher from "expo-intent-launcher";

// ----------------------------------------------------------------------------

export default function SharedPage(props, { route }) {
  // -------------------------------------
  // Props Destructuring
  // -------------------------------------

  const { style, composition, onClose } = props;

  // const navigation = useNavigation();
  const [selectedIndex, setSelectedIndex] = useState(0);

  function renderComposition() {
    return (
      <div>
        <div style={{ maxHeight: "10vh" }}>
          <div className="row">
            <BackIcon onClick={onClose}></BackIcon>
            <div style={{ marginTop: 3 }}>
              <div className="row">
                <AppText bold>{composition?.title?.it}</AppText>
                <AppText>/ {composition?.title?.en}</AppText>
              </div>
              {composition?.subTitle && (
                <div className="row">
                  <AppText small bold>
                    {composition?.subTitle?.it}
                  </AppText>
                  <AppText small>/ {composition?.subTitle?.en}</AppText>
                </div>
              )}
            </div>
          </div>

          <div>
            {/* <HeaderActions
                  downloadPress={() => {
                    screenAndShare();
                  }}
                  sharePress={() => {
                    screenAndShare();
                  }}
                  priceListPress={() => navigation.navigate("DownloadsNav")}
                ></HeaderActions> */}
          </div>
        </div>

        {composition &&
          composition?.products?.map(
            (product, index) =>
              index === selectedIndex && (
                <div>
                  {/* small image */}
                  <div className="row">
                    <div className="column" style={{ width: "70%" }}>
                      <img
                        src={require(`../${composition?.title?.en
                          ?.replace(" ", "")
                          .replace("-", "")}/images/subImgs/${
                          product?.detailImage
                        }.svg`)}
                        style={{
                          width: 160,
                          maxHeight: "10vh",
                          objectPosition: "left",
                        }}
                        alt=""
                      />
                    </div>
                  </div>
                  {/* sizes and image */}
                  <div className="row" style={{ height: "62vh" }}>
                    {/* sizes  */}
                    <div
                      className="column"
                      style={{
                        width: "30%",
                        display: "flex",
                        flexWrap: "wrap",
                        flexDirection: "column",
                        justifyContent: "flex-end",
                        maxHeight: "60vh",
                      }}
                    >
                      {product?.size && (
                        <div>
                          <div style={{ marginTop: 6 }}>
                            {product?.size?.heightsText ? (
                              <div className="row" style={{ marginTop: 6 }}>
                                <AppText small bold>
                                  {product?.size?.heightsText?.it}
                                </AppText>
                                <AppText small>
                                  / {product?.size?.heightsText?.en}
                                </AppText>
                              </div>
                            ) : (
                              <div className="row" style={{ marginTop: 6 }}>
                                <AppText small bold>
                                  altezze
                                </AppText>
                                <AppText small>/ heights</AppText>
                              </div>
                            )}

                            <AppText small>{product?.size?.height}</AppText>
                          </div>
                          {product?.size?.heightsText1 && (
                            <div style={{ marginTop: 6 }}>
                              <div className="row" style={{ marginTop: 6 }}>
                                <AppText small bold>
                                  {product?.size?.heightsText1?.it}
                                </AppText>
                                <AppText small>
                                  / {product?.size?.heightsText1?.en}
                                </AppText>
                              </div>
                              <AppText small>{product?.size?.height1}</AppText>
                            </div>
                          )}
                          <div className="row" style={{ marginTop: 6 }}>
                            <AppText small bold>
                              larghezze
                            </AppText>
                            <AppText small>/ widths</AppText>
                          </div>
                          <AppText small>{product?.size?.widths}</AppText>
                          <div className="row" style={{ marginTop: 6 }}>
                            <AppText small bold>
                              profondità
                            </AppText>
                            <AppText small>/ depths</AppText>
                          </div>
                          <AppText small>{product?.size?.depths}</AppText>
                        </div>
                      )}
                    </div>
                    {/* text  */}
                    <div
                      className="column"
                      style={{
                        width: "65%",
                        alignItems: "flex-end",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-end",
                      }}
                    >
                      <div
                        style={{
                          alignItems: "flex-end",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "flex-end",
                        }}
                      >
                        <AppText
                          small
                          style={{
                            color:
                              product?.room === "Home" ? "#d89d30" : "#8b8a79",
                          }}
                          bold
                          noSpace
                        >
                          {product?.code}
                        </AppText>

                        <div className="row">
                          <AppText
                            small
                            bold
                            style={{
                              color:
                                product?.room === "Home"
                                  ? "#d89d30"
                                  : "#8b8a79",
                            }}
                          >
                            {product?.name?.it}
                          </AppText>
                          <AppText
                            small
                            style={{
                              color:
                                product?.room === "Home"
                                  ? "#d89d30"
                                  : "#8b8a79",
                            }}
                          >
                            / {product?.name?.en}
                          </AppText>
                        </div>
                      </div>
                      {/* images  */}
                      <SlideImages
                        top
                        image={product?.sourceImage}
                        onPlus={() =>
                          composition?.products?.length !== selectedIndex + 1
                            ? setSelectedIndex(selectedIndex + 1)
                            : setSelectedIndex(0)
                        }
                        onMinus={() =>
                          selectedIndex !== 0
                            ? setSelectedIndex(selectedIndex - 1)
                            : setSelectedIndex(
                                composition?.products?.length - 1
                              )
                        }
                        style={{
                          height: "53vh",
                          objectFit: "contain",
                          objectPosition: "center",
                          minWidth: "40vw",
                        }}
                        noCenter
                        showArrows={composition?.products?.length > 1}
                      ></SlideImages>
                    </div>
                  </div>
                </div>
              )
          )}
      </div>
    );
  }

  return (
    <Modal
      open={true}
      className="modal"
      bodyStyle={{ height: "85vh", overflowY: "auto" }}
      centered
      footer={[]}
      closable={false}
    >
      {renderComposition()}
    </Modal>
  );
}
// -------------------------------------
// Component PropTypes and default props
// -------------------------------------
